import { CallApi } from '@signavio/kraken'

import { RestoreWorkflowVersionType } from '../../../types'

import { schema } from './version'

export { collection, schema } from './version'

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { versionId, workflowId }: RestoreWorkflowVersionType) =>
    callApi(
      `${apiBase}/workflows/${workflowId}/versions/${versionId}/restore`,
      schema,
      {
        method: 'POST',
      }
    )
